export default __webpack_public_path__ + "static/media/alex.edf45aab.jpg";